import axios from "axios";
import { showToast, showDialog } from "vant";
import { createI18n } from "vue-i18n";
import { load } from '@/utils/loading'
import router from '@/router/index'
import { isInChina } from "@/utils/commonUtils";
import messages from "@/locales/i18n-messages";
import { getCurrentLanguage } from "@/effects/switchLanguageEffect";

import {
    saveLoginAccessToken,
    saveLoginRefreshToken,
    getLoginAccessToken,
    getLoginRefreshToken,
    getLanguageFlag,
    logout,
    isLogin,

    isDistributorUser,
    isRetailerUser,
    isIndividualUser,
    isDirectVendorUser,
    isSupplierUser,
    isSystemUser,
} from "@/utils/localStorageUtils";




import { loaderror } from "@/utils/errorPopup";



// let baseUrl = 'https://mb.dev.castrol-autofilm.com/nbiz/cfilm/'
// let baseUrl = 'http://192.168.31.170:20101/nbiz'
// let baseUrl = 'http://192.168.0.225:20101/nbiz'

// let baseUrl = 'https://mb.ks-test.youbanban.com/nbiz/'
let baseUrl = 'https://mb.ks.youbanban.com/nbiz/'


let baseOldUrl = isInChina() ? 'https://www.castrol-autofilm.com.cn/nbiz/cfilm' : 'https://www.castrol-autofilm.com/nbiz/cfilm'
let baseFileUrl = isInChina() ? 'https://www.castrol-autofilm.com.cn/web/nbiz/cfilm' : 'https://www.castrol-autofilm.com/web/nbiz/cfilm'
let baseMdUrl = 'https://img.youbanban.com/oss/download/castrolautofilm/doc/guide'

// 

const instance = axios.create({
    // baseURL: 'https://mb.dev.youbanban.com/strawberry/',
    baseURL: baseUrl,
    timeout: 12 * 1000, // 超时时间 正式环境
    // timeout: 25 * 1000, // 超时时间 测试环境
    // timeout: 22 * 1000, // 超时时间
    // baseURL: 'http://192.168.22.248:9830/strawberry/',
})

const pureAxios = axios.create({
    timeout: 12 * 1000, // 超时时间
}); // 这是一个完全干净的实例，没有任何 baseURL
const instanAuth = axios.create({
    baseURL: baseUrl,
    timeout: 10 * 1000,
});

const instanPdf = axios.create({
    baseURL: baseFileUrl,
    timeout: 15 * 1000,
})

const instanMd = axios.create({
    baseURL: baseMdUrl,
    timeout: 15 * 1000,
})
const i18n = createI18n({
    locale: getCurrentLanguage(),
    messages,
});

const { t } = i18n.global;
const instanOld = axios.create({
    baseURL: baseOldUrl,
    timeout: 15 * 1000,
})
// 192.168.22.248:9830/strawberry/airPort/entryCountry/query/goods/list

const openUrlList = [];

const adapterAllApi = (url) => {
    // 检测到有open的话 就直接放行
    if (url.includes('/open')) {
        // 公开接口
        return url;
    }
    if (isDistributorUser()) {
        return '/distributor-user' + url;
    }
    if (isRetailerUser()) {
        // 零售商
        return '/retailer-user' + url;
    }
    if (isIndividualUser()) {
        // 消费者    
        return '/individual-user' + url;
    }
    if (isDirectVendorUser()) {
        // 直营商
        return '/direct-vendor-user' + url;
        // return '/system-user' + url;
    }
    if (isSupplierUser()) {
        // 供应商
        return '/supplier-user' + url;
    }
    if (isSystemUser()) {
        // 系统
        return '/system-user' + url;
    }
    return url;

}


instanOld.interceptors.request.use(
    (config) => {
        if (config.showloading) {
            load.show()
        }
        if (config.tokenFlag) {
            // 但是没有登录态的话 就直接跳到登录页面
            if (!isLogin()) {
                load.hide();
                logout();
                router.replace({ name: 'Login' })
            } else {
                config.headers["Authorization"] = `Bearer ${getLoginAccessToken()}`;
                // config.headers["Accept-Language"] = isInChina() ?getLanguageFlag() 'zh-CN' : 'en-US';


            }
        }
        config.headers["Accept-Language"] = getLanguageFlag() === 'zh-TW' ? 'zh-CN' : getLanguageFlag();
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        load.hide()
        return Promise.reject(error);
    }
);



let NOT_NEED_SORTBY_LIST = ['/open/country/query-list', '/open/province/query-list', '/nbiz/open/city/query-list', '/open/district/query-list'];

instance.interceptors.request.use(
    (config) => {
        if (config.showloading) {
            load.show()
        }
        if (config.tokenFlag) {
            // 但是没有登录态的话 就直接跳到登录页面
            if (!isLogin()) {
                load.hide();
                logout();
                router.replace({ name: 'Login' })
            } else {
                config.headers["Authorization"] = `Bearer ${getLoginAccessToken()}`;
                // config.headers["Accept-Language"] = isInChina() ? 'zh-CN' : 'en-US';

            }
        }
        config.headers["Accept-Language"] = getLanguageFlag() === 'zh-TW' ? 'zh-CN' : getLanguageFlag();
        // config.headers["Accept-Language"] = 'zh-CN';
        if (config.method === "get") {
            // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
            // config.paramsSerializer = function (params) {
            //     return qs.stringify(params, {
            //         arrayFormat: "repeat",
            //     });
            // };

            // if (!config.url.includes('Timestamp:desc')) {

            // }
            // console.log("config.url", config.url);
            if (NOT_NEED_SORTBY_LIST.includes(config.url)) {
                return config;
            }
            if (config.url.indexOf('?') == -1) {
                config.url += `?sortBy=createTimestamp:desc`;
            } else {
                config.url += `&sortBy=createTimestamp:desc`;
            }





        }

        return config;
    },
    (error) => {
        // 对请求错误做些什么
        load.hide()
        return Promise.reject(error);
    }
);

const simpleErrorList = ['/nbiz/cfilm/public/sms-verification-code/send'];
// 先暂时排除  因为国内的还没上
const excludeList = ['/dealer/query/list', '/dealer-apply/create', '/dealer-apply/create'];

instanOld.interceptors.response.use(async (response) => {
    load.hide()
    console.log('interceptors response11', response)
    if (response.data.error != null) {
        // if (simpleErrorList.indexOf(response.data.path) === -1) {
        //     loaderror.show({ traceId: response.data.traceId, code: response.data.error.code, message: response.data.error.message, detail: response.data.error.detail });
        // } else {
        //     showToast(response.data.error.message ? response.data.error.message : 'error')
        // }

        // 入库时候 提示信息更改 后端暂且无法更改 前端更改处理
        if (response.data.error.message == 'Car film product instance is pending stock') {
            response.data.error.message = 'Car film product instance is not pending stock'
        }
        let errorDetail = '';
        if (response.data.error.detail) {
            errorDetail = `\n( ${response.data.error.detail} )`
        }
        showToast({
            message: response.data.error.message ? response.data.error.message + errorDetail : 'error',
            wordBreak: "break-word",
        })
        // showToast(response.data.error.message ? response.data.error.message + errorDetail : 'error')
    }
    const originalRequest = response.config;

    if ('004' == response.headers['x-authorization-status']) {
        if (!originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = getLoginRefreshToken();
            const res = await instanAuth({
                method: "post",
                url: '/open/user/token-refresh',
                headers: {
                    "Authorization": `Bearer ${refreshToken}`,
                },
            })
                // .then((res) => {
                //     saveLoginAccessToken(res.data.data.cfilmUserToken.accessToken);
                //     saveLoginRefreshToken(res.data.data.cfilmUserToken.refreshToken)
                //     return instance(originalRequest)
                // })
                .catch(error => {
                    // 请重新登录
                    logout();
                    router.replace({ name: 'Login' })
                })
            console.log('res004', res)
            saveLoginAccessToken(res.data.data.token.accessToken);
            saveLoginRefreshToken(res.data.data.token.refreshToken);
            // saveLoginAccessToken(res.data.data.cfilmUserToken.accessToken);
            // saveLoginRefreshToken(res.data.data.cfilmUserToken.refreshToken)
            return instance(originalRequest)
        }
        else {
            logout();
            router.replace({ name: 'Login' })
        }
    }
    // 返回的就是响应体的内容
    return response.data;
}, async (error) => {
    console.log('interceptors response 22', error)
    load.hide()


    if (error.status == '401') {
        const originalRequest = error.config;
        if ('004' == error.response.headers['x-authorization-status']) {
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                const refreshToken = getLoginRefreshToken();
                const res = await instanAuth({
                    method: "post",
                    url: '/open/user/token-refresh',
                    headers: {
                        "Authorization": `Bearer ${refreshToken}`,
                    },
                })
                    // .then((res) => {
                    //     saveLoginAccessToken(res.data.data.cfilmUserToken.accessToken);
                    //     saveLoginRefreshToken(res.data.data.cfilmUserToken.refreshToken)
                    //     return instance(originalRequest)
                    // })
                    .catch(error => {
                        // 请重新登录
                        logout();
                        router.replace({ name: 'Login' })
                    })
                console.log('res004', res)
                saveLoginAccessToken(res.data.data.token.accessToken);
                saveLoginRefreshToken(res.data.data.token.refreshToken);
                // saveLoginAccessToken(res.data.data.cfilmUserToken.accessToken);
                // saveLoginRefreshToken(res.data.data.cfilmUserToken.refreshToken)
                return instance(originalRequest)
            }
            else {
                logout();
                router.replace({ name: 'Login' })
            }
        }
    }


    // 做的对于国内的兼容 
    if (excludeList.indexOf(error.config.url) === -1) {
        showToast(error.message ? error.message : 'error')
    }
    // 做的对于国内的兼容 

    return Promise.reject(error.message ? error.message : 'error'); // 返回接口返回的错误信息
})

instance.interceptors.response.use(async (response) => {
    load.hide()
    console.log('interceptors response 33', response)
    if (response.data.error != null) {
        // if (simpleErrorList.indexOf(response.data.path) === -1) {
        //     loaderror.show({ traceId: response.data.traceId, code: response.data.error.code, message: response.data.error.message, detail: response.data.error.detail });
        // } else {
        //     showToast(response.data.error.message ? response.data.error.message : 'error')
        // }

        // 入库时候 提示信息更改 后端暂且无法更改 前端更改处理
        if (response.data.error.message == 'Car film product instance is pending stock') {
            response.data.error.message = 'Car film product instance is not pending stock'
        }
        let errorDetail = '';
        if (response.data.error.detail) {
            errorDetail = `\n( ${response.data.error.detail} )`
        }
        showToast({
            message: response.data.error.message ? response.data.error.message + errorDetail : 'error',
            wordBreak: "break-word",
        })
        // showToast(response.data.error.message ? response.data.error.message + errorDetail : 'error')
    }
    const originalRequest = response.config;

    if ('004' == response.headers['x-authorization-status']) {
        if (!originalRequest._retry) {
            originalRequest._retry = true;
            const refreshToken = getLoginRefreshToken();
            const res = await instanAuth({
                method: "post",
                url: '/open/user/token-refresh',
                headers: {
                    "Authorization": `Bearer ${refreshToken}`,
                },
            })
                // .then((res) => {
                //     saveLoginAccessToken(res.data.data.cfilmUserToken.accessToken);
                //     saveLoginRefreshToken(res.data.data.cfilmUserToken.refreshToken)
                //     return instance(originalRequest)
                // })
                .catch(error => {
                    // 请重新登录
                    logout();
                    router.replace({ name: 'Login' })
                })
            console.log('res004', res)
            saveLoginAccessToken(res.data.data.token.accessToken);
            saveLoginRefreshToken(res.data.data.token.refreshToken);
            // saveLoginAccessToken(res.data.data.cfilmUserToken.accessToken);
            // saveLoginRefreshToken(res.data.data.cfilmUserToken.refreshToken)
            return instance(originalRequest)
        }
        else {
            logout();
            router.replace({ name: 'Login' })
        }
    }
    // 返回的就是响应体的内容
    return response.data;
}, async (error) => {
    console.log('interceptors response 44', error)
    load.hide()
    if (error.status == '401') {
        const originalRequest = error.config;
        if ('004' == error.response.headers['x-authorization-status']) {
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                const refreshToken = getLoginRefreshToken();
                const res = await instanAuth({
                    method: "post",
                    url: '/open/user/token-refresh',
                    headers: {
                        "Authorization": `Bearer ${refreshToken}`,
                    },
                })
                    // .then((res) => {
                    //     saveLoginAccessToken(res.data.data.cfilmUserToken.accessToken);
                    //     saveLoginRefreshToken(res.data.data.cfilmUserToken.refreshToken)
                    //     return instance(originalRequest)
                    // })
                    .catch(error => {
                        // 请重新登录
                        logout();
                        router.replace({ name: 'Login' })
                    })
                console.log('res004', res)
                saveLoginAccessToken(res.data.data.token.accessToken);
                saveLoginRefreshToken(res.data.data.token.refreshToken);
                // saveLoginAccessToken(res.data.data.cfilmUserToken.accessToken);
                // saveLoginRefreshToken(res.data.data.cfilmUserToken.refreshToken)
                return instance(originalRequest)
            }
            else {
                logout();
                router.replace({ name: 'Login' })
            }
        }
    }

    // 做的对于国内的兼容 
    if (excludeList.indexOf(error.config.url) === -1) {
        showToast(error.message ? error.message : 'error')
    }
    // 做的对于国内的兼容 
    if (error.status == '404' || error.message == 'Request failed with status code 404') {

        showDialog({
            title: t("app.request.error_info"),
            message: JSON.stringify(error),
            confirmButtonText: t("app.request.copy")
        }).then(async () => {
            await navigator.clipboard.writeText(JSON.stringify(error)); // 需要 HTTPS 或 localhos
            // on close t
        });
    }

    return Promise.reject(error.message ? error.message : 'error'); // 返回接口返回的错误信息
})



export const post = (url, data = {}) => {
    return new Promise((resolve, reject) => {
        instance.post(url, data,
            {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'air_port_admin_token': getUserToken() || ''
                }
            }
        )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            });
    })
}

export const postFile = (url, data = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.post(url, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'air_port_admin_token': getUserToken() || ''
                }
            }
        )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            });
    })
}


export const put = (url, data = {}) => {
    return new Promise((resolve, reject) => {
        instance.put(url, data,
            {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'air_port_admin_token': getUserToken() || ''
                }
            }
        )
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}

export const get = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params,
            tokenFlag,
            showloading: false,
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}
export const oldget = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instanOld.get(url, {
            params,
            tokenFlag,
            showloading: false,
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}


export const getloading = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.get(adapterAllApi(url), {
            params,
            tokenFlag,
            showloading: true,
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}

// 带角色前缀、但不带 loading 的 GET（用于轮询等场景，避免 loading 反复闪现）
export const getnolo = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.get(adapterAllApi(url), {
            params,
            tokenFlag,
            showloading: false,
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}

// 专门给地图等第三方完整 URL 使用，不走 adapterAllApi / baseURL
export const getloadingmap = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        pureAxios.get(url, {
            params,
            tokenFlag,
            showloading: true,
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}

export const getchartloading = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params,
            tokenFlag,
            showloading: true,
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}

export const oldgetloading = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instanOld.get(url, {
            params,
            tokenFlag,
            showloading: true,
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}


export const getloadingGoogle = (url, params = {}, tokenFlag = false, is) => {
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params,
            // headers: {
            //     'air_port_admin_token': getUserToken() || ''
            // },
            tokenFlag,
            showloading: true,
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}



export const getbolbloading = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instanPdf.get(url, {
            params,
            tokenFlag,
            showloading: true,
            responseType: "blob"
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}

export const getmdbolbloading = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instanMd
            .get(url, {
                params,
                tokenFlag,
                showloading: true,
                responseType: "blob"
            })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}




export const postloading = (url, params = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.post(adapterAllApi(url), params,
            {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                tokenFlag,
                showloading: true,
            }
        )
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}


export const postfileloading = (url, data = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.post(url, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // 'air_port_admin_token': getUserToken() || ''
                },
                tokenFlag,
                showloading: true,
            }
        )
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}

export const postfile = (url, data = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.post(url, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // 'air_port_admin_token': getUserToken() || ''
                },
                tokenFlag,
            }
        )
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}

export const longtimeoutpostfile = (url, data = {}, tokenFlag) => {
    return new Promise((resolve, reject) => {
        instance.post(url, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // 'air_port_admin_token': getUserToken() || ''
                },
                tokenFlag,
                timeout: 60 * 1000, // 本次请求 1分钟 超时
            }
        )
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                console.log('catch error', error)
            });
    })
}


